import { VerticalBarToolTip, VerticalBarToolTipArrow, VerticalBarToolTipZone } from "styles/bar";

import React from "react";
import colors from "styles/colors";
import formatMetricValue from "../../modules/utils/formatMetricValue";
import useRect from "modules/utils/useRect";

const MyToolTip = ({ tooltipModel, metric }) => {
  //eslint-disable-next-line no-unused-vars
  const [rect, ref] = useRect();
  const value = formatMetricValue(metric, tooltipModel.dataPoints[0].value);
  const left = tooltipModel.caretX - (ref.current ? ref.current.offsetWidth / 2 : 0);
  const top = tooltipModel.caretY - 40;
  return (
    <VerticalBarToolTipZone top={top} left={left} ref={ref}>
      <VerticalBarToolTip
        fontSize="10px"
        bold={false}
        color={colors.tooltip2Text}
        bgColor={colors.tooltip2}
        radius={ref.current ? ref.current.offsetHeight / 2 + "px" : null}
      >
        {value}
      </VerticalBarToolTip>
      <VerticalBarToolTipArrow bgColor={colors.tooltip2} />
    </VerticalBarToolTipZone>
  );
};

const trendingToolTip = (tooltipModel, setTooltip, metric) => {
  if (tooltipModel.body) setTooltip(<MyToolTip tooltipModel={tooltipModel} metric={metric} />);
  if (tooltipModel.opacity === 0) setTooltip(null);
};

export default trendingToolTip;
